import script from "./DirectoryLogosRow.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectoryLogosRow.vue?vue&type=script&setup=true&lang=js"

import "./DirectoryLogosRow.vue?vue&type=style&index=0&id=0cd8995f&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cd8995f"]])

export default __exports__